"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.regexp.search");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _org = require("@/api/org");
var _disctimeslogs = require("@/api/disctimeslogs");
var _region = require("@/api/region");
var _utils = require("@/utils");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _vueTreeselect = _interopRequireDefault(require("@riophae/vue-treeselect"));
require("@riophae/vue-treeselect/dist/vue-treeselect.css");
var _commissionbranches = require("@/api/commissionbranches");
var _user = require("@/api/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultOrg = {
  name: '',
  parent: null,
  type: '部门',
  // type弃用
  department_type: null,
  dept_pinyin: '',
  dept_desc: '',
  charge_name: '',
  charge_contact: '',
  province_code: null,
  city_code: null,
  district_code: null,
  sales_type: null,
  commission_branches: null,
  addrs: '',
  is_commission: 1
};
var defaultAssignData = {
  dept_now: null,
  allot_times: null
};
var checkNumber = function checkNumber(rule, value, callBack) {
  if (!Number(value * 1) && value * 1 !== 0) {
    callBack(new Error('请输入合法的数值'));
  } else {
    if (value * 1 < 0) {
      callBack(new Error('分润比率不能小于0'));
    } else {
      callBack();
    }
  }
};
var _default = exports.default = {
  components: {
    Treeselect: _vueTreeselect.default
  },
  data: function data() {
    return {
      confirmButtonDisabled: false,
      org: {
        id: '',
        name: '',
        parent: '',
        type: '',
        department_type: null,
        dept_pinyin: '',
        dept_desc: '',
        charge_name: '',
        charge_contact: '',
        province_code: '',
        city_code: '',
        district_code: '',
        sales_type: null,
        commission_branches: null,
        addrs: '',
        is_commission: 1
      },
      commissionData: {
        organization: '',
        plan_type: '',
        commision: [{
          commissionBranch: 1,
          profit_rate: '',
          profit_amount: null,
          branch_desc: null
        }, {
          commissionBranch: 2,
          profit_rate: '',
          profit_amount: null,
          branch_desc: null
        }, {
          commissionBranch: 3,
          profit_rate: '',
          profit_amount: null,
          branch_desc: null
        }, {
          commissionBranch: 4,
          profit_rate: '',
          profit_amount: null,
          branch_desc: null
        }, {
          commissionBranch: 5,
          profit_rate: '',
          profit_amount: null,
          branch_desc: null
        }, {
          commissionBranch: 6,
          profit_rate: '',
          profit_amount: null,
          branch_desc: null
        }, {
          commissionBranch: 10,
          profit_rate: '',
          profit_amount: null,
          branch_desc: null
        }]
      },
      commissionUpdateData: {
        plan_type: '',
        commision: [{
          id: '',
          commissionBranch: '',
          profit_rate: '',
          profit_amount: null,
          branch_desc: null
        }, {
          id: '',
          commissionBranch: '',
          profit_rate: '',
          profit_amount: null,
          branch_desc: null
        }, {
          id: '',
          commissionBranch: '',
          profit_rate: '',
          profit_amount: null,
          branch_desc: null
        }, {
          id: '',
          commissionBranch: '',
          profit_rate: '',
          profit_amount: null,
          branch_desc: null
        }, {
          id: '',
          commissionBranch: '',
          profit_rate: '',
          profit_amount: null,
          branch_desc: null
        }, {
          id: '',
          commissionBranch: '',
          profit_rate: '',
          profit_amount: null,
          branch_desc: null
        }, {
          id: '',
          commissionBranch: '',
          profit_rate: '',
          profit_amount: null,
          branch_desc: null
        }]
      },
      charge_name: [],
      assignData: {
        dept_now: '',
        allot_times: ''
      },
      search: '',
      tableData: [],
      orgList: [],
      profitOptions: [{
        key: 1,
        display_name: '渠道商'
      }, {
        key: 2,
        display_name: '运维团队'
      }, {
        key: 3,
        display_name: '设备所属单位'
      }, {
        key: 4,
        display_name: 'C端机构'
      }, {
        key: 5,
        display_name: 'TTS专家工作室'
      }, {
        key: 6,
        display_name: 'TTS方案归属团队'
      }, {
        key: 10,
        display_name: '新汉方公司'
      }],
      wayOptions: [{
        key: 1,
        display_name: '付款比例'
      }, {
        key: 2,
        display_name: '固定金额',
        disabled: true
      }],
      confirmOptions: [{
        key: 0,
        display_name: '不接收'
      }, {
        key: 1,
        display_name: '接收'
      }],
      levelOptions: [{
        key: '1',
        display_name: '公司'
      }, {
        key: '2',
        display_name: '销售渠道'
      }, {
        key: '3',
        display_name: '省代理商'
      }, {
        key: '4',
        display_name: '市代理商'
      }, {
        key: '5',
        display_name: '区代理商'
      }, {
        key: '6',
        display_name: '其它代理商'
      }, {
        key: '7',
        display_name: '运维团队'
      }, {
        key: '8',
        display_name: '医疗机构'
      }],
      typeOptions: [{
        key: 'qudao',
        display_name: '渠道'
      }, {
        key: '部门',
        display_name: '部门'
      }, {
        key: 'yiyuan',
        display_name: '医院'
      }],
      deptTypeOptions: [{
        key: 1,
        display_name: '公立医疗机构'
      }, {
        key: 2,
        display_name: '经销商'
      }, {
        key: 3,
        display_name: '民营医疗机构'
      }],
      salesTypeOptions: [{
        key: 0,
        display_name: '销售部门'
      }, {
        key: 1,
        display_name: '非销售部门'
      }],
      planOptions: [{
        key: 0,
        display_name: '松散管控(公立)'
      }, {
        key: 1,
        display_name: '标准管控(民营)'
      }],
      listQuery: {
        page: 1,
        page_size: 20
      },
      listLoading: true,
      dialogVisible: false,
      dialogType: 'new',
      rule1: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        parent: [{
          required: true,
          message: '请选择上级',
          trigger: 'change'
        }],
        number: [{
          required: true,
          message: '请输入分配盘次数',
          trigger: 'blur'
        }],
        commission_branches: [{
          required: true,
          message: '请选择分润单位',
          trigger: 'change'
        }],
        sales_type: [{
          required: true,
          message: '请选择部门类型',
          trigger: 'change'
        }],
        plan: [{
          required: true,
          message: '请选择管控方案',
          trigger: 'change'
        }],
        is_commission: [{
          required: true,
          message: '请选择是否接收分润订单',
          trigger: 'change'
        }]
      },
      rule2: {
        dept_now: [{
          required: true,
          message: '请选择分配部门',
          trigger: 'blur'
        }],
        allot_times: [{
          required: true,
          message: '请输入分配盘次数',
          trigger: 'blur'
        }]
      },
      rule3: {
        way: [{
          required: true,
          message: '请选择分润方式',
          trigger: 'change'
        }]
      },
      dialogAssignVisible: false,
      dialogAssignType: 'new',
      maxCount: 1000000,
      provinceData: [],
      cityData: [],
      defaultCity: [],
      districtData: [],
      defaultDistrict: [],
      user: [],
      cout: '',
      parentData: {},
      dialogDetailVisible: false,
      path: [],
      checkNumber1: checkNumber
    };
  },
  computed: {},
  created: function created() {
    this.getUserList();
    this.getList();
    this.getProvinceAll();
    this.getCityAll();
    this.getDistrictAll();
    this.getParentData();
  },
  methods: {
    checkPermission: _permission.default,
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _org.getOrgAll)(this.listQuery).then(function (response) {
        if (response.data) {
          _this.orgList = response.data;
          var data = (0, _utils.genTree)(response.data);
          _this.tableData = data;
          console.log(_this.tableData);
        }
        _this.listLoading = false;
      });
    },
    getParentData: function getParentData() {
      var _this2 = this;
      (0, _org.getOrgAll)().then(function (response) {
        _this2.parentData = (0, _utils.genTree)(response.data);
      });
    },
    getProvinceAll: function getProvinceAll() {
      var _this3 = this;
      (0, _region.getProvinceAll)().then(function (response) {
        _this3.provinceData = response.data;
      });
    },
    provinceChange: function provinceChange(val) {
      var _this4 = this;
      this.cityData = [];
      this.org.city_code = '';
      this.org.district_code = '';
      this.defaultCity.forEach(function (item) {
        var item_city = Object.assign({}, item);
        _this4.cityData.push(item_city);
      });
      var province_code = this.provinceData.filter(function (item) {
        return item.id === val;
      })[0].province_code;
      this.cityData = this.cityData.filter(function (item) {
        return item.province_code === province_code;
      });
    },
    getCityAll: function getCityAll() {
      var _this5 = this;
      (0, _region.getCityAll)().then(function (response) {
        _this5.defaultCity = response.data;
        _this5.cityData = [];
        _this5.defaultCity.forEach(function (item) {
          var item_city = Object.assign({}, item);
          _this5.cityData.push(item_city);
        });
      });
    },
    cityChange: function cityChange(val) {
      var _this6 = this;
      this.districtData = [];
      this.org.district_code = '';
      this.defaultDistrict.forEach(function (item) {
        var item_district = Object.assign({}, item);
        _this6.districtData.push(item_district);
      });
      var city_code = this.cityData.filter(function (item) {
        return item.id === val;
      })[0].city_code;
      this.districtData = this.districtData.filter(function (item) {
        return item.city_code === city_code;
      });
    },
    getDistrictAll: function getDistrictAll() {
      var _this7 = this;
      (0, _region.getDistrictAll)().then(function (response) {
        _this7.defaultDistrict = response.data;
        _this7.districtData = [];
        _this7.defaultDistrict.forEach(function (item) {
          var item_district = Object.assign({}, item);
          _this7.districtData.push(item_district);
        });
      });
    },
    resetFilter: function resetFilter() {
      this.getList();
    },
    handleFilter: function handleFilter() {
      var _this8 = this;
      var newData = this.orgList.filter(function (data) {
        return !_this8.search || data.name.toLowerCase().includes(_this8.search.toLowerCase());
      });
      this.tableData = (0, _utils.genTree)(newData);
    },
    handleFilterProfit: function handleFilterProfit() {
      this.listQuery.page = 1;
      this.getList();
    },
    getChargeName: function getChargeName(id) {
      var _this9 = this;
      console.log(id);
      (0, _user.getUserList)({
        dept: id
      }).then(function (response) {
        _this9.charge_name = response.data.results;
        console.log(_this9.charge_name);
      });
    },
    handleAdd: function handleAdd() {
      var _this10 = this;
      this.org = Object.assign({}, defaultOrg);
      this.commissionData.organization = '';
      this.commissionData.plan_type = '';
      for (var i = 0; i < this.commissionData.commision.length; i++) {
        this.commissionData.commision[i].profit_rate = '';
      }
      this.charge_name.length = 0;
      this.dialogType = 'new';
      this.dialogVisible = true;
      this.confirmButtonDisabled = false;
      this.$nextTick(function () {
        _this10.$refs['Form'].clearValidate();
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this11 = this;
      this.getChargeName(scope.row.id);
      this.org = Object.assign({}, scope.row); // copy obj
      this.cityData = [];
      if (this.org.province_code) {
        var province_code = this.provinceData.filter(function (item) {
          return item.id === _this11.org.province_code;
        })[0].province_code;
        this.defaultCity.forEach(function (item) {
          if (item.province_code === province_code) {
            var item_city = Object.assign({}, item);
            _this11.cityData.push(item_city);
          }
        });
      }
      this.districtData = [];
      if (this.org.city_code) {
        var city_code = this.cityData.filter(function (item) {
          return item.id === _this11.org.city_code;
        })[0].city_code;
        this.defaultDistrict.forEach(function (item) {
          if (item.city_code === city_code) {
            var item_district = Object.assign({}, item);
            _this11.districtData.push(item_district);
          }
        });
      }
      this.org.commission_branches = '';
      if (this.org.sales_type === 0) {
        this.org.commission_branches = scope.row.commission_branches;
      }
      this.commissionData.organization = '';
      this.commissionData.plan_type = '';
      for (var i = 0; i < this.commissionData.commision.length; i++) {
        this.commissionData.commision[i].profit_rate = '';
      }
      if (this.org.sales_type === 0 && this.org.parent === 1) {
        (0, _org.getOrg)(this.org.id).then(function (response) {
          var arr = [];
          arr = response.data.commissionbranch_detail;
          console.log(arr);
          _this11.commissionData.plan_type = arr[0].plan_type;
          _this11.commissionUpdateData.plan_type = arr[0].plan_type;
          var _loop = function _loop(_i) {
            if (_i === arr.length - 1) {
              var index = arr.findIndex(function (x) {
                return x.commissionBranch === 10;
              });
              _this11.commissionData.commision[_i].profit_rate = (arr[index].profit_rate * 100).toFixed(3);
            } else {
              var _index = arr.findIndex(function (x) {
                return x.commissionBranch === _i + 1;
              });
              _this11.commissionData.commision[_i].profit_rate = (arr[_index].profit_rate * 100).toFixed(3);
            }
            _this11.commissionUpdateData.commision[_i] = arr[_i];
          };
          for (var _i = 0; _i < arr.length; _i++) {
            _loop(_i);
          }
        });
        console.log(this.commissionData.commision[0]);
      }
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.confirmButtonDisabled = false;
      console.log(this.org);
      this.$nextTick(function () {
        _this11.$refs['Form'].clearValidate();
      });
    },
    // handleConfigXinHanFang(scope) {
    //   this.assignData = Object.assign({}, defaultAssignData) // copy obj
    //   this.assignData.dept_now = scope.row.id
    //   this.dialogAssignType = 'new'
    //   this.dialogAssignVisible = true
    //   this.$nextTick(() => {
    //     this.$refs['AssignForm'].clearValidate()
    //   })
    // },
    handleAssign: function handleAssign() {
      var _this12 = this;
      this.assignData = Object.assign({}, defaultAssignData); // copy obj
      if (!this.$store.state.user.issuperuser && this.$store.state.user.dept) {
        this.maxCount = this.orgList.filter(function (item) {
          return item.id === _this12.$store.state.user.dept;
        })[0].remain_times;
        this.maxCount = this.maxCount ? this.maxCount : 0;
      } else if (this.$store.state.user.issuperuser) {
        this.maxCount = 1000000;
      } else {
        this.maxCount = 0;
      }
      // this.maxCount = scope.row.remain_times
      this.dialogAssignType = 'edit';
      this.dialogAssignVisible = true;
      this.$nextTick(function () {
        _this12.$refs['AssignForm'].clearValidate();
      });
    },
    handleDelete: function handleDelete(scope) {
      var _this13 = this;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _org.deleteOrg)(scope.row.id);
            case 2:
              _this13.getList();
              _this13.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    confirmOrg: function () {
      var _confirmOrg = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(form, form1) {
        var _this14 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this14.dialogType === 'edit';
                  if (_this14.org.sales_type === 0 && _this14.org.parent === 1) {
                    _this14.$refs[form1].validate(function (valid2) {
                      if (valid2) {
                        _this14.confirmButtonDisabled = true;
                        setTimeout(function () {
                          // 这里是函数代码
                          this.confirmButtonDisabled = false;
                        }, 3000);
                        _this14.sendConfirm();
                      } else {
                        return false;
                      }
                    });
                  } else {
                    _this14.confirmButtonDisabled = true;
                    _this14.sendConfirm();
                    setTimeout(function () {
                      // 这里是函数代码
                      this.confirmButtonDisabled = false;
                    }, 3000);
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function confirmOrg(_x, _x2) {
        return _confirmOrg.apply(this, arguments);
      }
      return confirmOrg;
    }(),
    // async confirmOrg(form, form1) {
    //   const rule1 = new Promise((resolve, reject) => {
    //     this.$refs[form].validate(valid => {
    //       if (valid) {
    //         console.log(0)
    //         resolve()
    //       } else {
    //         console.log(1)
    //         return false
    //       }
    //     })
    //   })
    //   if (this.org.sales_type === 0 && this.org.parent === 1) {
    //     const rule2 = new Promise((resolve, reject) => {
    //       this.$refs[form1].validate(valid => {
    //         if (valid) {
    //           console.log(2)
    //           resolve()
    //         } else {
    //           console.log(3)
    //           return false
    //         }
    //       })
    //     })
    //     Promise.all([rule1, rule2]).then(() => {
    //       this.sendConfirm()
    //     })
    //     return
    //   }
    //   Promise.all([rule1]).then(() => {
    //     this.sendConfirm()
    //   })
    // },
    sendConfirm: function sendConfirm() {
      var _this15 = this;
      var isEdit = this.dialogType === 'edit';
      if (isEdit) {
        if (this.org.sales_type === 0 && this.org.parent === 1) {
          this.commissionUpdateData.plan_type = this.commissionData.plan_type;
          var _loop2 = function _loop2(i) {
            console.log(_this15.commissionUpdateData.commision[i]);
            if (_this15.commissionData.commision[i].profit_rate === 0) {
              _this15.commissionUpdateData.commision[i].profit_rate = 0 .toFixed(3);
            } else {
              if (i === _this15.commissionUpdateData.commision.length - 1) {
                var index = _this15.commissionUpdateData.commision.findIndex(function (x) {
                  return x.commissionBranch === 10;
                });
                _this15.commissionUpdateData.commision[index].profit_rate = (_this15.commissionData.commision[i].profit_rate / 100).toFixed(3);
              } else {
                var _index2 = _this15.commissionUpdateData.commision.findIndex(function (x) {
                  return x.commissionBranch === i + 1;
                });
                _this15.commissionUpdateData.commision[_index2].profit_rate = (_this15.commissionData.commision[i].profit_rate / 100).toFixed(3);
              }
            }
          };
          for (var i = 0; i < this.commissionUpdateData.commision.length; i++) {
            _loop2(i);
          }
          console.log(this.commissionUpdateData);
          (0, _commissionbranches.updateCommissionBranch)(this.org.id, this.commissionUpdateData).then(function (response) {
            console.log(response.data);
          });
        }
        (0, _org.updateOrg)(this.org.id, this.org).then(function () {
          _this15.getList();
          _this15.dialogVisible = false;
          _this15.$message({
            message: '编辑成功',
            type: 'success'
          });
        });
      } else {
        (0, _org.createOrg)(this.org).then(function (res) {
          if (res.data.sales_type === 0 && res.data.parent === 1) {
            _this15.commissionData.organization = res.data.id;
            console.log(_this15.commissionData.plan_type);
            console.log(_this15.commissionData.organization);
            for (var _i2 = 0; _i2 < _this15.profitOptions.length; _i2++) {
              console.log(_this15.commissionData.commision[_i2]);
              if (_this15.commissionData.commision[_i2].profit_rate === '0') {
                _this15.commissionData.commision[_i2].profit_rate = 0 .toFixed(3);
              } else {
                _this15.commissionData.commision[_i2].profit_rate = (_this15.commissionData.commision[_i2].profit_rate / 100).toFixed(3);
              }
              console.log(_this15.commissionData.commision[_i2]);
            }
            console.log(_this15.commissionData);
            (0, _commissionbranches.createCommissionBranches)(_this15.commissionData).then(function (response) {
              console.log(_this15.commissionData);
            });
          }
          // this.org = res.data
          // this.tableData.unshift(this.org)
          _this15.getList();
          _this15.dialogVisible = false;
          _this15.$message({
            message: '新增成功',
            type: 'success'
          });
        });
      }
    },
    confirmAssign: function () {
      var _confirmAssign = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(assignform) {
        var _this16 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.$refs[assignform].validate(function (valid) {
                if (valid) {
                  (0, _disctimeslogs.createDisctimesLogs)(_this16.assignData).then(function (res) {
                    _this16.getList();
                    _this16.dialogAssignVisible = false;
                    _this16.$message({
                      message: '分配成功',
                      type: 'success'
                    });
                  });
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function confirmAssign(_x3) {
        return _confirmAssign.apply(this, arguments);
      }
      return confirmAssign;
    }(),
    getValue: function getValue() {
      for (var i = 0; i < 7; i++) {
        console.log(this.commissionData.commision[i].profit_rate);
      }
      if (this.commissionData.commision[0].profit_rate !== '' && this.commissionData.commision[1].profit_rate !== '' && this.commissionData.commision[2].profit_rate !== '' && this.commissionData.commision[3].profit_rate !== '' && this.commissionData.commision[4].profit_rate !== '' && this.commissionData.commision[5].profit_rate !== '') {
        this.commissionData.commision[6].profit_rate = (100 - this.commissionData.commision[0].profit_rate - this.commissionData.commision[1].profit_rate - this.commissionData.commision[2].profit_rate - this.commissionData.commision[3].profit_rate - this.commissionData.commision[4].profit_rate - this.commissionData.commision[5].profit_rate).toFixed(3);
        console.log(this.commissionData.commision[6].profit_rate);
      } else {
        console.log(1);
        return;
      }
    },
    getBranch: function getBranch(branch) {
      if (branch === null) {
        branch = '无';
      } else {
        var index = this.profitOptions.findIndex(function (x) {
          return x.key === branch;
        });
        branch = this.profitOptions[index]['display_name'];
      }
      return branch;
    },
    getName: function getName(name) {
      if (name !== '' && name !== null) {
        // console.log(name)
        var index = this.user.findIndex(function (x) {
          return x.id === Number(name);
        });
        // console.log(index)
        if (index === -1) {
          name = '';
        } else {
          name = this.user[index]['name'];
        }
      } else {
        name = '';
      }
      return name;
    },
    getUserList: function getUserList() {
      var _this17 = this;
      (0, _user.getUserList)().then(function (response) {
        _this17.count = response.data.count;
        console.log(_this17.count);
        (0, _user.getUserList)({
          page: 1,
          page_size: _this17.count
        }).then(function (response) {
          _this17.user = response.data.results;
          console.log(_this17.user);
        });
      });
    },
    getPhone: function getPhone() {
      var _this18 = this;
      if (this.org.charge_name !== '') {
        (0, _user.getUser)(this.org.charge_name).then(function (response) {
          if (response.data) {
            _this18.org.charge_contact = response.data.phone;
          } else {
            _this18.org.charge_contact = '';
          }
        });
      } else {
        this.org.charge_contact = '';
      }
    },
    handleView: function handleView(scope) {
      this.path.length = 0;
      this.dialogDetailVisible = true;
      this.getTreePath(this.parentData, function (data) {
        return data.name === scope.row.name;
      }, this.path);
      console.log(this.path);
    },
    getTreePath: function getTreePath(tree, func, path) {
      if (!tree) return [];
      var _iterator = (0, _createForOfIteratorHelper2.default)(tree),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var data = _step.value;
          path.push(data.name);
          if (func(data)) return path;
          if (data.children) {
            var findChildren = this.getTreePath(data.children, func, path);
            if (findChildren.length) return findChildren;
          }
          path.pop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return [];
    }
  }
};